<script setup lang="ts">
const portfolio = usePortfolioStore()
const p = portfolio.profile
const avatar = computed(() => resolveMediaUrl(p?.avatar))
const typed = ref('')
const root = ref<HTMLElement | null>(null)
let cleanup: (() => void) | undefined
let typingTimer: ReturnType<typeof setInterval> | undefined
let mounted = true

onMounted(async () => {
  const full = p?.job_title ?? ''
  let i = 0
  if (full) {
    typingTimer = setInterval(() => {
      typed.value = full.slice(0, ++i)
      if (i >= full.length) clearInterval(typingTimer)
    }, 70)
  }

  if (!root.value || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

  const { default: gsap } = await import('gsap')
  const rootElement = root.value
  if (!mounted || !rootElement) return

  const context = gsap.context(() => {
    gsap.from('[data-hero]', {
      opacity: 0,
      y: 24,
      duration: 0.8,
      stagger: 0.12,
      ease: 'power3.out',
      delay: 0.2
    })
  }, rootElement)

  cleanup = () => context.revert()
})

onBeforeUnmount(() => {
  mounted = false
  cleanup?.()
  clearInterval(typingTimer)
})
</script>

<template>
  <section id="hero" ref="root" class="relative overflow-hidden px-1 py-12 text-center md:py-16">
    <div class="pointer-events-none absolute inset-x-0 -top-28 h-52 bg-accent/10 blur-[110px]"></div>
    <img v-if="avatar" :src="avatar" :alt="p?.fullname" data-hero
         class="mx-auto h-28 w-28 rounded-full border-2 border-accent/70 object-cover glow md:h-36 md:w-36" />
    <h1 data-hero class="mt-6 text-3xl font-extrabold md:text-5xl">
      سلام، من <span class="text-accent">{{ p?.fullname }}</span> هستم
    </h1>
    <p data-hero class="mt-3 text-lg text-accent-2 md:text-xl">{{ typed }}<span class="animate-pulse">|</span></p>
    <p data-hero class="mx-auto mt-5 max-w-xl text-sm leading-7 text-muted md:text-base">{{ p.experience }}</p>
    <div data-hero class="mt-8 flex flex-wrap items-center justify-center gap-3">
      <a href="#projects"
         class="rounded-full bg-accent px-7 py-3.5 text-sm font-bold text-bg-deep glow transition duration-300
                ease-[cubic-bezier(.2,.8,.2,1)] hover:-translate-y-1 hover:scale-[1.03] hover:tracking-wide
                hover:shadow-[0_14px_36px_var(--t-accent-soft)] active:translate-y-0 active:scale-[.99]">دیدن نمونه‌کارها</a>
      <a :href="p.cv.url" target="_blank" rel="noopener noreferrer" v-if="p.cv"
         class="rounded-full border border-line px-7 py-3.5 text-sm font-bold text-ink transition duration-300
                ease-[cubic-bezier(.2,.8,.2,1)] hover:-translate-y-1 hover:border-accent hover:bg-[var(--t-accent-soft)]
                hover:text-accent active:translate-y-0">دریافت رزومه</a>
    </div>
  </section>
</template>
